"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1947],{

/***/ 83685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ knowledge_library_KnowledgeLibrary; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/hooks/useRouter.ts
var useRouter = __webpack_require__(98377);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layout/LayoutAdapter.tsx
var LayoutAdapter = __webpack_require__(39891);
// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
// EXTERNAL MODULE: ./src/utils/collection.utils.ts
var collection_utils = __webpack_require__(85295);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/utils/normalizers/collection.ts
var collection = __webpack_require__(36493);
// EXTERNAL MODULE: ./src/utils/source.utils.ts
var source_utils = __webpack_require__(15959);
// EXTERNAL MODULE: ./src/utils/normalizers/profile.ts
var profile = __webpack_require__(7269);
// EXTERNAL MODULE: ./src/utils/normalizers/source.ts + 1 modules
var source = __webpack_require__(27079);
;// CONCATENATED MODULE: ./src/utils/normalizers/knowledgeLibrary.ts



var normalizeKLSource = function(data) {
    var _author, _image_color;
    return {
        id: data.id,
        ideas: data.blocks.map(function(idea) {
            return (0,source/* normalizeIdea */.NA)(idea);
        }),
        publishStash: data.stash_published_in ? {
            id: data.stash_published_in.id,
            ideaCount: -1,
            emoji: data.stash_published_in.emoji,
            name: data.stash_published_in.name
        } : undefined,
        status: data.status,
        title: data.title,
        sourceType: data.type,
        sourceSubtype: 0,
        suggestedBlocks: [],
        userData: (0,profile/* normalizeUserData */.Te)(data.user_data),
        author: (_author = data.author) !== null && _author !== void 0 ? _author : undefined,
        content: undefined,
        description: data.description,
        image: data.image,
        imageColor: (_image_color = data.image_color) !== null && _image_color !== void 0 ? _image_color : (0,source_utils/* getSourceThemeColor */.Dv)(data.type, "light"),
        imageBlurhash: undefined,
        similarArticles: [],
        topic: [],
        url: data.url,
        suggestedTopics: [],
        context: data.context,
        totalComments: data.total_comments,
        totalReactions: data.total_reactions,
        topReactions: data.top_reactions.map(source/* normalizeTopReaction */.MR),
        totalReads: data.total_reads
    };
};

// EXTERNAL MODULE: ./src/components/collection/CollectionCard.tsx
var CollectionCard = __webpack_require__(72426);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsed.tsx + 2 modules
var SourceCollapsed = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/components/story/StoryCard.tsx
var StoryCard = __webpack_require__(82049);
;// CONCATENATED MODULE: ./src/components/knowledge-library/components/ScrollWrapperOriginal.tsx




var ScrollWrapperOriginal = function(param) {
    var items = param.items, displayGrid = param.displayGrid, sideBySide = param.sideBySide;
    return sideBySide ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Grid, {
        gridTemplateColumns: {
            base: "repeat(1, 1fr)",
            lg: "repeat(2, 1fr)"
        },
        ml: "0",
        style: style.gridContainerStyle,
        gridGap: global/* GAP_SIZE_REM */.L3,
        children: items
    }) : displayGrid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Grid, {
        gridTemplateColumns: {
            base: "repeat(1, 1fr)",
            lg: "repeat(3, 1fr)"
        },
        ml: {
            base: "0",
            lg: "-10px"
        },
        style: style.gridContainerStyle,
        children: items
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        style: style.listContainerStyle,
        children: items
    });
};
var style = {
    listContainerStyle: {
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column"
    },
    gridContainerStyle: {
        justifyContent: "center",
        alignItems: "center"
    }
};
/* harmony default export */ var components_ScrollWrapperOriginal = (ScrollWrapperOriginal);

;// CONCATENATED MODULE: ./src/components/knowledge-library/KnowledgeLibrary.tsx

















var KnowledgeLibrary = function(param) {
    var data = param.data, currentSectionState = param.currentSectionState;
    var router = (0,useRouter/* default */.Z)();
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var getArticlesDescriptionItems = (0,react.useCallback)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        if (!data) return {
            article1: "",
            domain1: "",
            domain2: ""
        };
        var sortedArticles = (0,_to_consumable_array/* default */.Z)(data.list).sort(function(a, b) {
            var ref, ref1;
            return (((ref = a.title) === null || ref === void 0 ? void 0 : ref.length) || 0) - (((ref1 = b.title) === null || ref1 === void 0 ? void 0 : ref1.length) || 0);
        });
        var i = 0;
        while((((ref = sortedArticles[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.length) || 0) === 0 && i < sortedArticles.length - 1)i++;
        var ref7;
        var domainUrl1 = sortedArticles[i] ? (0,global/* getDomainName */.p7)((ref7 = (ref2 = sortedArticles[i]) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref7 !== void 0 ? ref7 : "") : "";
        var ref8;
        var domainUrl2 = sortedArticles[i + 1].url ? (0,global/* getDomainName */.p7)((ref8 = (ref3 = sortedArticles[i + 1]) === null || ref3 === void 0 ? void 0 : ref3.url) !== null && ref8 !== void 0 ? ref8 : "") : "";
        return {
            article1: (ref4 = sortedArticles[i]) === null || ref4 === void 0 ? void 0 : ref4.title,
            domain1: ((ref5 = domainUrl1.charAt(0)) === null || ref5 === void 0 ? void 0 : ref5.toUpperCase()) + domainUrl1.slice(1),
            domain2: ((ref6 = domainUrl2.charAt(0)) === null || ref6 === void 0 ? void 0 : ref6.toUpperCase()) + domainUrl2.slice(1)
        };
    }, [
        data
    ]);
    var pageNumber = parseInt(typeof router.query.page === "string" ? router.query.page : "1");
    (0,react.useEffect)(function() {
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.consumption.viewKL */.z.consumption.viewKL,
            properties: {
                type: currentSectionState,
                page: pageNumber
            },
            platforms: [
                "amplitude"
            ]
        });
    }, []);
    if (!data) return null;
    var menuOptions = [
        {
            title: "Collections",
            key: "collections"
        },
        {
            title: "Articles",
            key: "articles"
        },
        {
            title: "Stories",
            key: "stories"
        }, 
    ];
    var renderHeader = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            width: "100%",
            align: isMobileView ? "flex-start" : "center",
            justifyContent: "space-between",
            flexDir: isMobileView ? "column" : "row",
            mb: global/* GAP_SIZE_REM */.L3,
            zIndex: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryHeading, {
                    size: "h1",
                    textSize: "l",
                    type: "bold",
                    fontSize: "32px",
                    zIndex: 1,
                    color: esm.color[colorMode].text,
                    lineHeight: "40px",
                    children: klPageMetadata.pageTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                    maxWidth: "100%",
                    flexWrap: "wrap",
                    children: menuOptions.map(function(menuOption) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            href: menuOption.key === "stories" ? "/stories" : "/" + menuOption.key + "/1",
                            as: menuOption.key === "stories" ? "/stories" : "/" + menuOption.key + "/1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                px: isMobileView ? esm.spacing.XS.rem : esm.spacing.M.rem,
                                py: isMobileView ? esm.spacing.XXS.rem : esm.spacing.XS.rem,
                                mr: isMobileView ? esm.spacing.XXS.rem : esm.spacing.XS.rem,
                                borderRadius: esm.spacing.L.rem,
                                backgroundColor: currentSectionState === menuOption.key ? esm.color[colorMode].top : esm.color.transparent,
                                _hover: {
                                    cursor: "pointer",
                                    backgroundColor: esm.color[colorMode].top
                                },
                                _active: undefined,
                                _focus: undefined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                    title: menuOption.title,
                                    _hover: undefined,
                                    _focus: undefined,
                                    href: menuOption.key === "stories" ? "/stories" : "/" + menuOption.key + "/1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                        size: isMobileView ? "s" : "m",
                                        color: esm.color[colorMode].textSecondary,
                                        children: menuOption.title
                                    })
                                })
                            })
                        }, menuOption.key);
                    })
                })
            ]
        });
    };
    var articleItems = function() {
        return data.list.map(function(article) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                source: normalizeKLSource(article),
                mb: esm.spacing.M.rem,
                width: "100%"
            }, "latestArticle$".concat(article.id));
        });
    };
    var collectionItems = function() {
        var _list;
        var collectionRows = (0,collection_utils/* groupCollectionCollapsedIntoRows */.wU)({
            collections: (0,collection/* normalizeCollections */.nn)((_list = data.list) !== null && _list !== void 0 ? _list : []),
            rowSize: 3
        });
        return collectionRows.map(function(collections, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                // bgColor="RED"
                width: "100%",
                justifyContent: "space-between",
                mt: index > 0 ? 32 : 0,
                children: collections.map(function(collection, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCard/* default */.Z, {
                        collection: {
                            id: collection.id,
                            image: collection.imageUrl,
                            image_blurhash: collection.imageBlurhash,
                            name: collection.name,
                            total_blocks: collection.ideaCount
                        }
                    }, "collection-".concat(index));
                })
            }, "row-collections-".concat(index));
        });
    };
    var storiesItems = function() {
        var _list;
        var storyRows = (0,global/* transformArrayToMatrix */.eB)({
            items: (_list = data.list) !== null && _list !== void 0 ? _list : [],
            rowSize: 3
        });
        return storyRows.map(function(stories, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                width: "100%",
                justifyContent: "space-between",
                mt: index > 0 ? 48 : 0,
                gridColumnGap: 16,
                children: stories.map(function(story, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryCard/* default */.Z, {
                        story: story,
                        imageWidth: "100%",
                        imageHeight: 160
                    }, "story-".concat(index));
                })
            }, "row-story-".concat(index));
        });
    };
    var getItems = function(currentSection) {
        switch(currentSection){
            case enums/* KlList.ARTICLES */.ij.ARTICLES:
                return articleItems();
            case enums/* KlList.COLLECTIONS */.ij.COLLECTIONS:
                return collectionItems();
            case enums/* KlList.STORIES */.ij.STORIES:
                return storiesItems();
            default:
                return [];
        }
    };
    var renderSection = function(currentSection) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
            flexDirection: "column",
            mb: "60px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ScrollWrapperOriginal, {
                items: getItems(currentSection),
                displayGrid: false
            })
        });
    };
    var renderPages = function() {
        var arr = [];
        var PAGES_MAX_NAVIGATION = isMobileView ? 1 : 3;
        if (pageNumber > PAGES_MAX_NAVIGATION + 1) {
            arr.push(1);
        }
        if (pageNumber > PAGES_MAX_NAVIGATION + 2) {
            arr.push(-1);
        }
        for(var i = Math.max(1, pageNumber - PAGES_MAX_NAVIGATION); i <= Math.min(pageNumber + PAGES_MAX_NAVIGATION, data.numberOfPages); i++){
            arr.push(i);
        }
        if (pageNumber < data.numberOfPages - PAGES_MAX_NAVIGATION - 1) {
            arr.push(-1);
        }
        if (pageNumber < data.numberOfPages - PAGES_MAX_NAVIGATION) {
            arr.push(data.numberOfPages);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            maxW: "100%",
            alignSelf: "center",
            mb: esm.spacing.XXXL.rem,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: router.asPath === "/stories/2" ? "/stories" : "/[currentSectionState]/[page]",
                    visibility: pageNumber > 1 ? "visible" : "hidden",
                    as: router.asPath === "/stories/2" ? "/stories" : "/".concat(currentSectionState, "/").concat(pageNumber - 1),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                        _hover: undefined,
                        _focus: undefined,
                        href: router.asPath === "/stories/2" ? "/stories" : "/".concat(currentSectionState, "/").concat(pageNumber - 1),
                        color: esm.color[colorMode].text,
                        title: (pageNumber - 1).toString(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                            transform: "rotate(180deg)",
                            _hover: {
                                cursor: "pointer"
                            },
                            px: esm.spacing.XS.rem,
                            py: esm.spacing.toRem(6),
                            mr: esm.spacing.XS.rem,
                            borderRadius: esm.spacing.L.rem,
                            align: "center",
                            justifyContent: "center",
                            color: esm.color[colorMode].textSecondary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CaretRightSvg, {})
                        })
                    })
                }),
                arr.map(function(element, index) {
                    return element === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: esm.spacing.M.rem,
                        py: esm.spacing.XS.rem,
                        mr: esm.spacing.XS.rem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                            color: esm.color[colorMode].text,
                            children: "..."
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        href: element === 1 ? "/stories" : "/[currentSectionState]/[page]",
                        as: element === 1 ? "/stories" : "/".concat(currentSectionState, "/").concat(element),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            borderRadius: esm.spacing.L.rem,
                            px: esm.spacing.M.rem,
                            py: esm.spacing.XS.rem,
                            mr: esm.spacing.XS.rem,
                            _hover: {
                                cursor: "pointer"
                            },
                            backgroundColor: element === pageNumber ? esm.color[colorMode].surface : esm.color[colorMode].top,
                            _active: undefined,
                            _focus: undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                _hover: undefined,
                                _focus: undefined,
                                href: element === 1 ? "/stories" : "/".concat(currentSectionState, "/").concat(element),
                                color: esm.color[colorMode].text,
                                title: (element || "").toString(),
                                children: element
                            })
                        })
                    }, "pageIndex".concat(index));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "/[currentSectionState]/[page]",
                    visibility: pageNumber < data.numberOfPages ? "visible" : "hidden",
                    as: "/".concat(currentSectionState, "/").concat(pageNumber + 1),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                        _hover: undefined,
                        _focus: undefined,
                        href: "/".concat(currentSectionState, "/").concat(pageNumber + 1),
                        color: esm.color[colorMode].text,
                        title: (pageNumber + 1).toString(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                            px: esm.spacing.XS.rem,
                            py: esm.spacing.toRem(6),
                            mr: esm.spacing.XS.rem,
                            borderRadius: esm.spacing.L.rem,
                            align: "center",
                            justifyContent: "center",
                            color: esm.color[colorMode].textSecondary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CaretRightSvg, {})
                        })
                    })
                })
            ]
        });
    };
    var getPageTitle = function(currentSection, pageNumber) {
        var title = "";
        switch(currentSection){
            case enums/* KlList.ARTICLES */.ij.ARTICLES:
                title += "Articles";
                break;
            case enums/* KlList.COLLECTIONS */.ij.COLLECTIONS:
                title += "Collections";
                break;
            case enums/* KlList.STORIES */.ij.STORIES:
                title += "Stories";
                break;
            default:
                break;
        }
        title += " Library";
        if (pageNumber > 1) title += " - Page " + pageNumber;
        return title;
    };
    var getPageDescription = function(currentSection) {
        var description = "";
        switch(currentSection){
            case enums/* KlList.ARTICLES */.ij.ARTICLES:
                var ref = getArticlesDescriptionItems(), article1 = ref.article1, domain1 = ref.domain1, domain2 = ref.domain2;
                description += "Discover and read amazing articles like ".concat(article1, " from ").concat(domain1, " or others from ").concat(domain2, ".");
                break;
            case enums/* KlList.COLLECTIONS */.ij.COLLECTIONS:
                description += "Read the collection of the week for free, or dive into the full list of collections with a Pro account.";
                break;
            case enums/* KlList.STORIES */.ij.STORIES:
                var _list;
                var stories = (_list = data.list) !== null && _list !== void 0 ? _list : [];
                if (stories.length > 0) {
                    description += "Discover top stories from dozens of topics, including ".concat(stories[0].title, ", ").concat(stories.length > 1 ? stories[1].title : "", " and more.");
                }
                break;
            default:
                break;
        }
        return description;
    };
    var klPageMetadata = {
        pageTitle: getPageTitle(currentSectionState, pageNumber),
        pageDescription: getPageDescription(currentSectionState),
        canonical: router.pathname === "/stories" ? "https://deepstash.com/stories" : "https://deepstash.com/".concat(currentSectionState, "/").concat(pageNumber),
        robotsTag: "index"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutAdapter/* default */.Z, {
        pageMetadata: klPageMetadata,
        withAdditionalInfoNsi: true,
        disableProAd: router.pathname === "/stories" || router.pathname === "/stories/[page]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            pt: isMobileView ? 0 : esm.spacing.M.rem,
            flexDir: "column",
            children: [
                renderHeader(),
                renderSection(currentSectionState),
                data.numberOfPages > 1 && renderPages()
            ]
        })
    });
};
/* harmony default export */ var knowledge_library_KnowledgeLibrary = (KnowledgeLibrary);


/***/ }),

/***/ 82049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var _navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63069);
/* harmony import */ var _image_NextImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91260);







 // Use it instead of own useRouter for fixing scroll problems


var STORY_IMAGE_SIZE = {
    WIDTH: 260,
    HEIGHT: 180,
    BORDER_RADIUS: 8
};
var StoryCard = function(_param) {
    var story = _param.story, _imageWidth = _param.imageWidth, imageWidth = _imageWidth === void 0 ? STORY_IMAGE_SIZE.WIDTH : _imageWidth, _imageHeight = _param.imageHeight, imageHeight = _imageHeight === void 0 ? STORY_IMAGE_SIZE.HEIGHT : _imageHeight, _imageBorderRadius = _param.imageBorderRadius, imageBorderRadius = _imageBorderRadius === void 0 ? STORY_IMAGE_SIZE.BORDER_RADIUS : _imageBorderRadius, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "story",
        "imageWidth",
        "imageHeight",
        "imageBorderRadius"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var storySlug = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return (0,utils_global__WEBPACK_IMPORTED_MODULE_5__/* .slugify */ .lV)(story.title);
    }, [
        story.title
    ]);
    var storyPageRoute = "/story/".concat(story.id, "/").concat(storySlug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        flexDirection: "column",
        width: imageWidth
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_NextImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                wrapperStyle: {
                    width: imageWidth,
                    height: imageHeight,
                    borderRadius: imageBorderRadius,
                    cursor: "pointer"
                },
                imageUrl: story.image,
                blurhash: story.image_blurhash,
                alt: "".concat(story.title, " Image"),
                priority: false,
                onClick: function() {
                    router.push(storyPageRoute);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.small.regular), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].textSecondary,
                mt: 8,
                children: "".concat(story.time_to_read, " min read")
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                href: storyPageRoute,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Link, {
                    _focus: undefined,
                    _hover: undefined,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.bold), {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                        noOfLines: 3,
                        mt: 16,
                        children: "".concat(story.title)
                    }))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.medium.regular), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].textSecondary,
                noOfLines: 3,
                mt: 16,
                children: "".concat(story.intro)
            }))
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StoryCard);


/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InView)));

//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 45363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
__webpack_unused_export__ = ({ value: true });
exports.h6 = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var json_ld_1 = __webpack_require__(82342);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.helmetJsonLdProp; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.JsonLd; } });
Object.defineProperty(exports, "h6", ({ enumerable: true, get: function () { return json_ld_1.jsonLdScriptProps; } }));


/***/ }),

/***/ 82342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helmetJsonLdProp = exports.jsonLdScriptProps = exports.JsonLd = void 0;
const React = __webpack_require__(67294);
function JsonLd(props) {
    return React.createElement("script", Object.assign({}, jsonLdScriptProps(props.item, props)));
}
exports.JsonLd = JsonLd;
function jsonLdScriptProps(item, options = {}) {
    return {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(item, safeJsonLdReplacer, options.space),
        },
    };
}
exports.jsonLdScriptProps = jsonLdScriptProps;
function helmetJsonLdProp(item, options = {}) {
    return {
        type: "application/ld+json",
        innerHTML: JSON.stringify(item, safeJsonLdReplacer, options.space),
    };
}
exports.helmetJsonLdProp = helmetJsonLdProp;
const ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;",
});
const ESCAPE_REGEX = new RegExp(`[${Object.keys(ESCAPE_ENTITIES).join("")}]`, "g");
const ESCAPE_REPLACER = (t) => ESCAPE_ENTITIES[t];
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
const safeJsonLdReplacer = (() => {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return (_, value) => {
        switch (typeof value) {
            case "object":
                // Omit null values.
                if (value === null) {
                    return undefined;
                }
                return value; // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value; // These values are not risky.
            case "string":
                return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
            default: {
                // We shouldn't expect other types.
                isNever(value);
                // JSON.stringify will remove this element.
                return undefined;
            }
        }
    };
})();
// Utility: Assert never
function isNever(_) { }


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

}]);